export default __webpack_public_path__ + "static/20_31-f1e9f2d1e0cb6a3841bd30b0f5b2c29d.png";